
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $1c30518d2111d8b4$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["aD4yq","index.77fbb168.js","jdYzZ","../ui-pack.01f87fb1.aac","45xip","../Dial_up_modem_noises.fcf212dc.aac","bWHoa","../Foret-fix.bf0ea3fb.aac","jPgG1","../Branches.65b0f8e3.m4a","czN8K","../Pelle.ce95812f.m4a","hGGpg","../Riviere.b3d87571.m4a","9m1AG","../Autoroute.a945b89c.m4a","ZBR7v","../Voiture_arriv.353e4d3b.m4a","hXoWV","../Radio_loin.145b3ba9.m4a","1wki2","../Course_mort.543d9aeb.m4a","k7ieK","../Course_mort_reverse.d7569a14.m4a","1LALR","../Attente_cig.2a7016e0.m4a","xvATA","../Attente_vapor.59622743.m4a","aikcf","../Voiture_entree.f030b173.m4a","1iw3e","../Pas.d3f95d51.m4a","l2AUn","../Fin1_gauche_jazz.62b83880.m4a","cYJnO","../Fin2_droite_electro.9cda9c9d.m4a"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $a4c2b5f01dd377d1$exports = {};

$parcel$export($a4c2b5f01dd377d1$exports, "load", function () { return $a4c2b5f01dd377d1$export$11e63f7b0f3d9900; });
$parcel$export($a4c2b5f01dd377d1$exports, "play", function () { return $a4c2b5f01dd377d1$export$899fbdb5fa08b653; });
$parcel$export($a4c2b5f01dd377d1$exports, "audioBuffers", function () { return $a4c2b5f01dd377d1$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $a4c2b5f01dd377d1$export$c2a342ec653dfb48 = {};
function $a4c2b5f01dd377d1$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($a4c2b5f01dd377d1$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $a4c2b5f01dd377d1$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $569bd9143eae2355$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $a4c2b5f01dd377d1$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $a4c2b5f01dd377d1$export$899fbdb5fa08b653(name, options = {}) {
    if ($a4c2b5f01dd377d1$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $569bd9143eae2355$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $569bd9143eae2355$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $569bd9143eae2355$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($569bd9143eae2355$export$33ed28de027e9482(options.initialGain), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $569bd9143eae2355$export$549ee30ac73cf40b; // custom function
    source.fade = $569bd9143eae2355$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $569bd9143eae2355$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $569bd9143eae2355$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $a4c2b5f01dd377d1$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $569bd9143eae2355$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $569bd9143eae2355$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $569bd9143eae2355$export$a078c61943f9dbbe;
const $569bd9143eae2355$export$d1d41f0cda037248 = [];
function $569bd9143eae2355$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $569bd9143eae2355$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $569bd9143eae2355$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $569bd9143eae2355$export$a078c61943f9dbbe.sampleRate);
}
function $569bd9143eae2355$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($569bd9143eae2355$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $569bd9143eae2355$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $569bd9143eae2355$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($569bd9143eae2355$export$33ed28de027e9482(fromLevel), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($569bd9143eae2355$export$33ed28de027e9482(level), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($569bd9143eae2355$export$33ed28de027e9482(level), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $569bd9143eae2355$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $569bd9143eae2355$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $569bd9143eae2355$export$33ed28de027e9482(db), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $569bd9143eae2355$export$33ed28de027e9482(db), $569bd9143eae2355$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($569bd9143eae2355$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $569bd9143eae2355$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $569bd9143eae2355$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $569bd9143eae2355$export$33390c3a9a83a2f() {
    $569bd9143eae2355$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $569bd9143eae2355$export$93c25f2590a5b540(source) {
    const index = $569bd9143eae2355$export$d1d41f0cda037248.indexOf(source);
    $569bd9143eae2355$export$d1d41f0cda037248.splice(index, 1);
}
function $569bd9143eae2355$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $569bd9143eae2355$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}


// Autrona Acoustic Computer Kernel Module: Screen
// Handle all text screen drawing, save/restore, lines management, styles,
// teletype animations and sequences of this UNIX-like terminal emulation.
// Utilities
//
// Project-wide utility functions
function $a63b441980d6fd57$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $a63b441980d6fd57$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $a63b441980d6fd57$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $a63b441980d6fd57$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $a63b441980d6fd57$var$newval;
function $a63b441980d6fd57$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $a63b441980d6fd57$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $a63b441980d6fd57$var$newval;
    if (start2 < stop2) return $a63b441980d6fd57$var$constrain($a63b441980d6fd57$var$newval, start2, stop2);
    return $a63b441980d6fd57$var$constrain($a63b441980d6fd57$var$newval, stop2, start2);
}



// Autrona Acoustic Computer Kernel Module: Keyboard
// Handle all key strokes, keep track of modifiers, 
// then pass the events to the currently running program,
// including main for control-sequences
// Configuration
const $fc2d960d846ce384$var$modifiers = [
    "Control"
];
const $fc2d960d846ce384$var$defaultPrevented = [
    " ",
    "ArrowUp",
    "ArrowDown"
];
// Variables
const $fc2d960d846ce384$export$58b6cc66cb100704 = [];
// Initialize module
function $fc2d960d846ce384$export$2cd8252107eb640b() {
    document.addEventListener("keydown", $fc2d960d846ce384$var$handleKeyDowns);
    document.addEventListener("keyup", $fc2d960d846ce384$var$handleKeyUps);
}
// General keydown event callback
function $fc2d960d846ce384$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    if ($fc2d960d846ce384$var$modifiers.includes(e.key)) $fc2d960d846ce384$var$addModifier(e.key);
    if ($fc2d960d846ce384$var$defaultPrevented.includes(e.key)) e.preventDefault();
}
// keyup event callback
function $fc2d960d846ce384$var$handleKeyUps(e) {
    if ($fc2d960d846ce384$var$modifiers.includes(e.key)) $fc2d960d846ce384$var$removeModifier(e.key);
}
// Modifier keys handling
function $fc2d960d846ce384$var$addModifier(key) {
    $fc2d960d846ce384$export$58b6cc66cb100704.push(key);
}
function $fc2d960d846ce384$var$removeModifier(key) {
    const modifierIndex = $fc2d960d846ce384$export$58b6cc66cb100704.indexOf(key);
    $fc2d960d846ce384$export$58b6cc66cb100704.splice(modifierIndex, 1);
}


// Variables
let $e1cdaf3feaf9d5df$var$screen;
let $e1cdaf3feaf9d5df$var$container;
let $e1cdaf3feaf9d5df$var$saveBuffer;
let $e1cdaf3feaf9d5df$var$unveilBuffer;
let $e1cdaf3feaf9d5df$var$currentLine;
let $e1cdaf3feaf9d5df$var$overflow = "scroll"; // scroll or clear
let $e1cdaf3feaf9d5df$var$timeout;
let $e1cdaf3feaf9d5df$var$timeoutBis;
const $e1cdaf3feaf9d5df$var$screenCols = 80;
const $e1cdaf3feaf9d5df$var$screenLines = 42;
// Initialize module
function $e1cdaf3feaf9d5df$export$2cd8252107eb640b() {
    $e1cdaf3feaf9d5df$var$screen = document.querySelector(".screen");
    $e1cdaf3feaf9d5df$var$container = document.querySelector(".container");
}
function $e1cdaf3feaf9d5df$export$c63191ea74413a1c(mode) {
    $e1cdaf3feaf9d5df$var$overflow = mode;
}
function $e1cdaf3feaf9d5df$export$a1544dad697b423d() {
    $e1cdaf3feaf9d5df$var$saveBuffer = $e1cdaf3feaf9d5df$var$screen.innerHTML;
}
function $e1cdaf3feaf9d5df$export$db239ef39aadc7fe() {
    clearTimeout($e1cdaf3feaf9d5df$var$timeout);
    clearTimeout($e1cdaf3feaf9d5df$var$timeoutBis);
    $e1cdaf3feaf9d5df$var$screen.innerHTML = $e1cdaf3feaf9d5df$var$saveBuffer;
    $e1cdaf3feaf9d5df$var$currentLine = $e1cdaf3feaf9d5df$var$screen.querySelector("p:last-of-type");
}
function $e1cdaf3feaf9d5df$export$42ffd38884aecdac(includePinned = true) {
    if (includePinned) {
        $e1cdaf3feaf9d5df$var$screen.innerHTML = "";
        $e1cdaf3feaf9d5df$var$currentLine = null;
        clearTimeout($e1cdaf3feaf9d5df$var$timeout);
        clearTimeout($e1cdaf3feaf9d5df$var$timeoutBis);
    } else $e1cdaf3feaf9d5df$var$screen.querySelectorAll("p:not(.pinned)").forEach((p)=>p.remove());
}
function $e1cdaf3feaf9d5df$export$10d8903dec122b9d(content, ...style) {
    if (style.length) $e1cdaf3feaf9d5df$export$3086f70939fb96fa(...style);
    $e1cdaf3feaf9d5df$var$currentLine.innerText += content;
    if (DEVMODE) $e1cdaf3feaf9d5df$var$checkLineLength($e1cdaf3feaf9d5df$var$currentLine.innerText);
    $e1cdaf3feaf9d5df$var$scroll();
}
function $e1cdaf3feaf9d5df$export$57ec1e98c75cb636(content, ...style) {
    if (style.length) $e1cdaf3feaf9d5df$export$3086f70939fb96fa(...style);
    $e1cdaf3feaf9d5df$var$currentLine.innerHTML += content;
    if (DEVMODE) $e1cdaf3feaf9d5df$var$checkLineLength($e1cdaf3feaf9d5df$var$currentLine.innerText);
    $e1cdaf3feaf9d5df$var$scroll();
}
function $e1cdaf3feaf9d5df$var$scroll() {
    // Scroll to bottom if necessary
    if ($e1cdaf3feaf9d5df$var$container.scrollTop !== $e1cdaf3feaf9d5df$var$container.scrollHeight) setTimeout(()=>{
        $e1cdaf3feaf9d5df$var$container.scrollTop = $e1cdaf3feaf9d5df$var$container.scrollHeight;
    }, 0);
}
function $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff(content, ...style) {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$10d8903dec122b9d(content, ...style);
}
function $e1cdaf3feaf9d5df$export$5a813221cd493211(content, ...style) {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$57ec1e98c75cb636(content, ...style);
}
function $e1cdaf3feaf9d5df$export$296e2d3e74e50369(content, ...style) {
    content.split("\n").forEach((c)=>$e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff(c, ...style));
}
function $e1cdaf3feaf9d5df$export$91698095bd4ff7e0(content, ...style) {
    content.split("\n").forEach((c)=>$e1cdaf3feaf9d5df$export$5a813221cd493211(c, ...style));
}
function $e1cdaf3feaf9d5df$var$checkLineLength(content) {
    if (content.length > $e1cdaf3feaf9d5df$var$screenCols) console.warn("Warning: Content is larger than screen columns: " + content.length, content);
}
// Delete one (or more if specified) characters from the screenBuffer
function $e1cdaf3feaf9d5df$export$1ea584ca7009bcc1(n = 1) {
    $e1cdaf3feaf9d5df$var$currentLine.innerText = $e1cdaf3feaf9d5df$var$currentLine.innerText.slice(0, -n);
}
function $e1cdaf3feaf9d5df$export$dc84f6841f96b7da() {
    // Remove blinking cursor and/or dots if active
    if ($e1cdaf3feaf9d5df$var$currentLine) $e1cdaf3feaf9d5df$var$currentLine.classList.remove("cursor");
    if ($e1cdaf3feaf9d5df$var$currentLine) $e1cdaf3feaf9d5df$var$currentLine.classList.remove("dots");
    // Limit screen rows to screenLines
    if ($e1cdaf3feaf9d5df$var$screen.querySelectorAll("p").length >= $e1cdaf3feaf9d5df$var$screenLines) {
        if ($e1cdaf3feaf9d5df$var$overflow === "clear") $e1cdaf3feaf9d5df$export$42ffd38884aecdac(false);
        else // Remove the first paragraph which is not pinned
        $e1cdaf3feaf9d5df$var$screen.querySelector("p:not(.pinned)").remove();
    }
    // Create a new paragraph
    const p = document.createElement("p");
    $e1cdaf3feaf9d5df$var$screen.appendChild(p);
    $e1cdaf3feaf9d5df$var$currentLine = p;
}
function $e1cdaf3feaf9d5df$export$b78008adb124fd21(n = 1) {
    for(let i = 0; i < n; i++){
        $e1cdaf3feaf9d5df$var$currentLine.remove();
        $e1cdaf3feaf9d5df$var$currentLine = $e1cdaf3feaf9d5df$var$screen.querySelector("p:last-of-type");
    }
}
function $e1cdaf3feaf9d5df$export$3086f70939fb96fa(...style) {
    $e1cdaf3feaf9d5df$var$currentLine.classList.add(...style);
}
function $e1cdaf3feaf9d5df$export$35bfa795e607ffd5() {
    $e1cdaf3feaf9d5df$var$currentLine.classList.add("pinned");
}
function $e1cdaf3feaf9d5df$export$58734539bbfa41a2() {
    $e1cdaf3feaf9d5df$var$currentLine.classList.add("cursor");
}
function $e1cdaf3feaf9d5df$export$e5383273bc7bedd() {
    // add three bouncing animated dots
    $e1cdaf3feaf9d5df$var$currentLine.classList.add("dots");
}
function $e1cdaf3feaf9d5df$export$6c9a7cc621cd09fe() {
    if ($e1cdaf3feaf9d5df$var$currentLine) $e1cdaf3feaf9d5df$var$currentLine.classList.remove("dots");
}
function $e1cdaf3feaf9d5df$export$36a3a8a63357453b(content, n = null) {
    if (n == null) n = $e1cdaf3feaf9d5df$var$screen.querySelectorAll("p").length;
    $e1cdaf3feaf9d5df$var$screen.querySelector(`p:nth-child(${n})`).innerHTML = content;
}
function $e1cdaf3feaf9d5df$export$14c7f8fd9e0dc60b() {
    const linesToFill = $e1cdaf3feaf9d5df$var$screenLines - $e1cdaf3feaf9d5df$var$screen.querySelectorAll("p").length;
    for(let i = 0; i < linesToFill; i++)$e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
}
// Automated teletype
// Will append `string` to the current line one character at a time,
// with `delay` milliseconds between each character.
function $e1cdaf3feaf9d5df$export$5938cf5cddbfce5a(string, delay = 33, callback = null) {
    if (string.length > 0) {
        let charDelay = delay;
        if (delay === "00" || delay == "human") charDelay = Math.floor(Math.random() * 8) ** 2 + 50;
        // Handle inline delays
        let inlineDelayMatch = string.match(/^(§([0-9]+)).*$/);
        if (inlineDelayMatch) {
            charDelay = inlineDelayMatch[2];
            string = string.replace(inlineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $fc2d960d846ce384$export$58b6cc66cb100704.includes("Control")) charDelay = 16;
        $e1cdaf3feaf9d5df$var$timeout = setTimeout(()=>{
            if (string.slice(0, 1) === "\xa7") $e1cdaf3feaf9d5df$export$1ea584ca7009bcc1();
            else $e1cdaf3feaf9d5df$export$10d8903dec122b9d(string.slice(0, 1));
            string = string.slice(1);
            $e1cdaf3feaf9d5df$export$5938cf5cddbfce5a(string, delay, callback);
        }, charDelay);
    } else if (typeof callback == "function") callback();
}
// Screen sequence
// A sequence of steps, each can be of different types
//  `Any text`         (string).     Will append the text to the current line.
//  `!n`               (new line).   Will open a new line.
//  `!c`               (clear).      Will clear the screen
//  `!s:my-class`      (CSS class).  Will add 'my-class' to the current line.
//  `!t:anytext:delay` (teletype).   Will teletype a string with given delay between each character
//  `!H:anytext      ` (HTML).       Will append the HTML to the current line.
//  `500`              (number).     Will delay further steps by X milliseconds.
function $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq, callback) {
    if (seq.length > 0) {
        const step = seq[0];
        if (typeof step == "string") {
            let matchNewLine = step.match(/^!n$/);
            let matchClear = step.match(/^!c$/);
            let matchStyle = step.match(/^!s:([a-z0-9\-]+)$/);
            let matchTeletype = step.match(/^!t:(.+):([0-9]+)$/);
            let matchHTML = step.match(/^!h:(.+)$/);
            switch(true){
                case matchNewLine != null:
                    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
                    break;
                case matchClear != null:
                    $e1cdaf3feaf9d5df$export$42ffd38884aecdac();
                    break;
                case matchStyle != null:
                    $e1cdaf3feaf9d5df$export$3086f70939fb96fa(matchStyle[1]);
                    break;
                case matchTeletype != null:
                    $e1cdaf3feaf9d5df$export$5938cf5cddbfce5a(matchTeletype[1], matchTeletype[2], ()=>{
                        // When teletype finished, recursively step ahead in sequence
                        $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq.slice(1), callback);
                    });
                    break;
                case matchHTML != null:
                    $e1cdaf3feaf9d5df$export$57ec1e98c75cb636(matchHTML[1]);
                    break;
                default:
                    $e1cdaf3feaf9d5df$export$10d8903dec122b9d(step);
            }
            // Recursively step ahead in sequence
            if (!matchTeletype) $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq.slice(1), callback);
        } else if (typeof step == "number") // Recursively step ahead in sequence with a milliseconds delay
        $e1cdaf3feaf9d5df$var$timeout = setTimeout(()=>{
            $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq.slice(1), callback);
        }, step);
    } else callback();
}
// New screen sequence
// A sequence of multi-line text which is to be rendered on screen
// Default mode is teletype, each caracter appended to screen one at a time
// with human-like timing.
// Handles a post-lead line delay token in the sequence: '§2000' for a 2s delay
// TODO: BBCode-like markup: (Should be implemented in teletype fonction ?)
//   - [s:col-green]...[/s] Styling with spans
function $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq, opts, callback = null) {
    const options = {
        /* Default options */ mode: "teletype",
        color: "col-orange",
        lead: "",
        lineDelay: 1000,
        dotsDelay: 2000,
        endDelay: 1000,
        newLineAtStart: true,
        newLineAtEnd: true,
        teletypeDelay: "human"
    };
    // Overwrite any default option with `opts` parameter
    $a63b441980d6fd57$export$10ce5528abfb398a(opts, options);
    if (seq.length > 0) {
        if (options.newLineAtStart) {
            $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
            options.newLineAtStart = false; // To cancel new line from recursive use
        }
        // Get sequence lines as an array
        let lines = seq.split("\n");
        // Get the first line
        let line = lines[0];
        // Remove any white-space around that line (code indents mostly)
        line = line.trim();
        openLine();
        // Find optional an line delay at the string's start (`§500` for a 500ms delay)
        let lineDelay = options.lineDelay;
        let lineDelayMatch = line.match(/^(§([0-9]+)).*$/);
        if (lineDelayMatch) {
            lineDelay = lineDelayMatch[2];
            line = line.replace(lineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $fc2d960d846ce384$export$58b6cc66cb100704.includes("Control")) lineDelay = 0;
        // After the first lead occurence, remove it
        options.lead = "";
        // Prepare remaining sequence (this line excluded) for recursive use
        const remainingSeq = lines.slice(1).join("\n");
        // For teletype, display dots after 2 seconds if the line delay is longer than 2 seconds
        if (options.mode === "teletype" && lineDelay > options.dotsDelay) $e1cdaf3feaf9d5df$var$timeoutBis = setTimeout($e1cdaf3feaf9d5df$export$e5383273bc7bedd, options.dotsDelay);
        $e1cdaf3feaf9d5df$var$timeout = setTimeout(()=>{
            // Default mode: teletype
            switch(options.mode){
                case "line":
                    $e1cdaf3feaf9d5df$export$6c9a7cc621cd09fe();
                    $e1cdaf3feaf9d5df$export$10d8903dec122b9d(line);
                    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(remainingSeq, options, callback);
                    break;
                case "teletype":
                    $e1cdaf3feaf9d5df$export$6c9a7cc621cd09fe();
                    const lines = $a63b441980d6fd57$export$89440da1893f4202(line, 80 - options.lead.length);
                    teletypeMultiline(lines.shift());
                    function teletypeMultiline(line) {
                        $e1cdaf3feaf9d5df$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Handling multiline teletype
                            if (lines.length) {
                                openLine();
                                teletypeMultiline(lines.shift());
                            } else // Recursively step ahead in sequence
                            $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }
                    break;
                case "message":
                    const charDelay = 100; // How much time per char before printing this line
                    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
                    $e1cdaf3feaf9d5df$var$timeout = setTimeout(()=>{
                        $e1cdaf3feaf9d5df$export$6c9a7cc621cd09fe();
                        $e1cdaf3feaf9d5df$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Recursively step ahead in sequence
                            $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }, line.length * charDelay);
                    break;
            }
        }, lineDelay);
    } else $e1cdaf3feaf9d5df$var$timeout = setTimeout(()=>{
        if (options.newLineAtEnd) $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
        if (callback) callback();
    }, options.endDelay);
    function openLine() {
        // Add lead
        $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff(options.lead);
        // Style line
        if (typeof options.color === "string") $e1cdaf3feaf9d5df$export$3086f70939fb96fa(options.color);
        else $e1cdaf3feaf9d5df$export$3086f70939fb96fa(...options.color);
    }
}
function $e1cdaf3feaf9d5df$export$d5cd9e826e7bdb85(callback) {
    // Analogue to save() but need its own buffer to keep save buffer intact
    $e1cdaf3feaf9d5df$var$unveilBuffer = $e1cdaf3feaf9d5df$var$screen.innerHTML;
    $e1cdaf3feaf9d5df$export$42ffd38884aecdac();
    const paragraphs = $e1cdaf3feaf9d5df$var$unveilBuffer.split("p><p");
    paragraphs.map((p, i)=>{
        if (i === 0) paragraphs[i] += "p>";
        else if (i === paragraphs.length - 1) paragraphs[i] = "<p" + paragraphs[i];
        else paragraphs[i] = "<p" + paragraphs[i] + "p>";
    });
    let i = 0;
    function step() {
        $e1cdaf3feaf9d5df$var$screen.innerHTML += paragraphs[i];
        $e1cdaf3feaf9d5df$var$currentLine = $e1cdaf3feaf9d5df$var$screen.querySelector("p:last-of-type");
        if (i < paragraphs.length - 1) $e1cdaf3feaf9d5df$var$timeout = setTimeout(step, LSI);
        else if (typeof callback === "function") callback();
        i++;
    }
    step();
}
// Display a choice list with optional title to be answered with a key press
// `answers` param is an object: { keyName: [answerText, callback]}
// Example:
//  screen.choice('Votre réponse:', {
//      '1': ['Ben.. Je sais pas trop...', passageB],
//      '2': ['Heu... Je vois rien...', passageC],
//  });
// Would yield:
//  Votre réponse:
//    [1] Ben.. Je sais pas trop...
//    [2] Heu... Je vois rien...
//  > 
function $e1cdaf3feaf9d5df$export$7a5825874deea16a(title, answers) {
    // Display optional title
    if (title) $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff(title);
    let seq = "";
    // Display one choice per line
    for (const [key, answer] of Object.entries(answers)){
        const indent = 5 + key.length;
        const maxLength = 80 - indent;
        const lines = $a63b441980d6fd57$export$89440da1893f4202(answer[0], maxLength);
        lines.forEach((line, index)=>{
            if (index === 0) seq += `[${key}] ${line}\n`;
            else seq += "".padStart(indent) + line + "\n";
        });
    }
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        color: "col-dark-cyan",
        lead: "",
        lineDelay: 100,
        endDelay: 100,
        mode: "line",
        newLineAtStart: false,
        newLineAtEnd: false
    }, ()=>{
        // Display prompt
        $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("> ", "col-cyan");
        $e1cdaf3feaf9d5df$export$58734539bbfa41a2();
        $dbf687474781ee90$export$a23ad60f6022999e("question");
    });
    registerKeyDownEvent();
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            const answer = Object.entries(answers).find((answer)=>answer[0] === e.key);
            if (answer) {
                $e1cdaf3feaf9d5df$export$10d8903dec122b9d(answer[1][0]);
                $dbf687474781ee90$export$a23ad60f6022999e("validate");
                answer[1][1]();
            } else {
                console.log("Invalid answer given:", e.key);
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}
function $e1cdaf3feaf9d5df$export$34c871b8a7d7e324(title, callback) {
    // Display optional title
    if (title) $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff(title);
    // Display prompt
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("> ", "col-cyan");
    $e1cdaf3feaf9d5df$export$58734539bbfa41a2();
    $dbf687474781ee90$export$a23ad60f6022999e("question");
    registerKeyDownEvent();
    let answer = "";
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            if (e.key == "Enter") {
                $dbf687474781ee90$export$a23ad60f6022999e("validate");
                callback(answer);
            } else if (e.key == "Backspace") {
                if (answer.length) {
                    // Remove last keystroke from command line on screen
                    $e1cdaf3feaf9d5df$export$1ea584ca7009bcc1();
                    // Remove last keystroke from command line
                    answer = answer.slice(0, -1);
                }
                registerKeyDownEvent();
            } else {
                if (e.key.length == 1) {
                    // Add keystroke to answer and screen buffer
                    answer += e.key;
                    $e1cdaf3feaf9d5df$export$10d8903dec122b9d(e.key);
                }
                // Enable next keystroke
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}


// Autrona Acoustic Computer Program: Remote
// Connect to a remote terminal



var $54444fb6f1edcc88$exports = {};

$parcel$export($54444fb6f1edcc88$exports, "init", function () { return $54444fb6f1edcc88$export$2cd8252107eb640b; });
$parcel$export($54444fb6f1edcc88$exports, "run", function () { return $54444fb6f1edcc88$export$889ea624f2cb2c57; });
$parcel$export($54444fb6f1edcc88$exports, "exit", function () { return $54444fb6f1edcc88$export$5c525e238923a57d; });
// Autrona Acoustic Computer Program: Pluie
// Une première expérience



// Variables
let $54444fb6f1edcc88$var$userName;
// Références à loops audio
const $54444fb6f1edcc88$var$oneShots = [];
const $54444fb6f1edcc88$var$loops = {};
let $54444fb6f1edcc88$var$timeout;
let $54444fb6f1edcc88$var$exitCallback;
// Niveaux Audio en décibels
//   0 db = unité = volume maximal
//   -90 db = volume à ~zéro
const $54444fb6f1edcc88$var$audioLevels = {
    // Niveaux absolus initiaux ou post fade-in
    "background": -3,
    "foret": 0,
    "branches": 0,
    "pelle": -12,
    "riviere": 0,
    "autoroute": -2,
    "voiture-arrive": 0,
    "radio-loin": -5,
    "course-mort": 0,
    "course-mort-rev": -6,
    "attente-cigarette": -6,
    "attente-vaporette": -6,
    "voiture-entree": 0,
    "pas": -8,
    "fin-jazz": 0,
    "fin-electro": 0,
    // Attenuations
    "attenuation-attente": -12,
    "attenuation-voiture": -90
};
// Initialize module
function $54444fb6f1edcc88$export$2cd8252107eb640b() {}
function $54444fb6f1edcc88$export$889ea624f2cb2c57(exitCb) {
    $54444fb6f1edcc88$var$exitCallback = exitCb;
    prompt = ""; // Reset
    $54444fb6f1edcc88$var$resetScreen();
    $dbf687474781ee90$export$a23ad60f6022999e("validate");
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        // Screen sequence. See screen.js comments for documentation
        const seq = `
            \xa73000 Votre num \xa7\xa7\xa7om ?
            `;
        $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            $e1cdaf3feaf9d5df$export$34c871b8a7d7e324(null, $54444fb6f1edcc88$var$passageA);
        });
    }, 2000);
}
function $54444fb6f1edcc88$var$resetScreen() {
    $e1cdaf3feaf9d5df$export$42ffd38884aecdac();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("AutronaTerm v2.5 - 802.11", "col-red", "col-bg-red");
    $e1cdaf3feaf9d5df$export$35bfa795e607ffd5();
}
function $54444fb6f1edcc88$var$passageA(answer) {
    $54444fb6f1edcc88$var$userName = answer;
    const seq = `
        \xa72000 Souvenez-vous...
        \xa75000 Souvenez-vous.
        
        \xa75000 Je sais que vous avez d\xe9j\xe0 v\xe9cu \xe7a.
        \xa75000 Comment les \xe9v\xe9nements s\u{2019}\xe9taient-ils encha\xeen\xe9s ?
        
        \xa77000 Vous \xe9tiez en for\xeat.
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $54444fb6f1edcc88$var$passageA1);
}
function $54444fb6f1edcc88$var$passageA1() {
    $54444fb6f1edcc88$var$loops.foret = $a4c2b5f01dd377d1$exports.play("foret", {
        loop: true,
        loopStart: 1.0,
        loopEnd: 50.116
    }).fadeTo(10, $54444fb6f1edcc88$var$audioLevels["foret"]);
    const seq = `
        \xa724000 Vous marchiez.
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $54444fb6f1edcc88$var$passageA2);
}
function $54444fb6f1edcc88$var$passageA2() {
    $54444fb6f1edcc88$var$loops.branches = $a4c2b5f01dd377d1$exports.play("branches", {
        loop: true
    }).fadeTo(1, $54444fb6f1edcc88$var$audioLevels["branches"]);
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        $54444fb6f1edcc88$var$loops.pelle = $a4c2b5f01dd377d1$exports.play("pelle", {
            loop: true
        }).fadeTo(15, $54444fb6f1edcc88$var$audioLevels["pelle"]);
    }, 20000);
    const seq = `
        \xa731000 Stop. Vous entendez ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $54444fb6f1edcc88$var$passageA3);
}
function $54444fb6f1edcc88$var$passageA3() {
    $54444fb6f1edcc88$var$loops.branches.fade(1, -90, true);
    const seq = `
        \xa710000 Ecoutez bien.
        \xa72000 Que fabrique-t-il ?
        
        \xa715000 Je suis s\xfbr que vous vous en souvenez.
        \xa74000 C\u{2019}est l\xe0 que tout a commenc\xe9 !
        
        \xa72000 Souvenez-vous...
        \xa75000 Que fabrique-t-il ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Ben... Je sais pas trop.",
                $54444fb6f1edcc88$var$passageB
            ],
            "2": [
                "Heu... Je vois rien.",
                $54444fb6f1edcc88$var$passageC
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageB() {
    const seq = `
        \xa73000 On m\u{2019}a dit que vous aviez l\u{2019}oreille fine...
        Est-ce une s\xe9v\xe8re perte de m\xe9moire ou un simple oubli ?
        
        \xa710000 Allez. dites-moi...
        
        \xa75000 O\xf9 se trouve-t-il ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        endDelay: 3000
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Au bord d\u2019une rivi\xe8re ?",
                $54444fb6f1edcc88$var$passageD
            ],
            "2": [
                "A moins que ce soit pr\xe8s de l\u2019autoroute...",
                $54444fb6f1edcc88$var$passageE
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageC() {
    const seq = `
        \xa72000 Et moi ?
        Vous croyez que je vois quelque chose ?
        Vous \xeates mes oreilles !
        
        \xa73000 Et ce sont vos souvenirs !

        \xa73000 Allez. dites-moi...
        
        \xa75000 O\xf9 se trouve-t-il ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        endDelay: 3000
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Heu... disons pr\xe8s d\u2019une autoroute. ",
                $54444fb6f1edcc88$var$passageE
            ],
            "2": [
                "Ou peut-\xeatre \xe0 c\xf4t\xe9 de la rivi\xe8re ?",
                $54444fb6f1edcc88$var$passageD
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageD() {
    $54444fb6f1edcc88$var$loops.riviere = $a4c2b5f01dd377d1$exports.play("riviere", {
        loop: true
    }).fadeTo(1.0, $54444fb6f1edcc88$var$audioLevels["riviere"]);
    const seq = `
        \xa72000 Bravo !
        
        Alors vous voyez... \xa71000 vous \xeates comme un d\xe9miurge !
        Les sons sont votre sp\xe9cialit\xe9... \xa71000 la musique... \xa71000 l\u{2019}encha\xeenement des bruits... \xa71000 une symphonie qui court sur la rivi\xe8re...
        
        \xa710000 Ne me dites pas que vous avez une m\xe9moire visuelle !
        On risque de mal s\u{2019}entendre.
        
        \xa75000 Bon, alors.
        \xa72000 Que fabrique-t-il ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Je crois qu\u2019il faisait juste des exercices physiques.",
                $54444fb6f1edcc88$var$passageF
            ],
            "2": [
                "Peut-\xeatre qu\u2019il creuse ?",
                $54444fb6f1edcc88$var$passageG
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageE() {
    $54444fb6f1edcc88$var$loops.autoroute = $a4c2b5f01dd377d1$exports.play("autoroute", {
        loop: true
    }).fadeTo(1.0, $54444fb6f1edcc88$var$audioLevels["autoroute"]);
    const seq = `
        \xa72000 Bravo !
        
        \xa74000 Alors vous voyez... vous \xeates comme un dieu cr\xe9ateur !

        Les sons sont votre sp\xe9cialit\xe9... la musique... l\u{2019}encha\xeenement des bruits...
        Une symphonie qui roule comme des voitures sur une autoroute...
        
        \xa710000 Ne me dites pas que vous avez une m\xe9moire visuelle !
        On risque de mal s\u{2019}entendre.
        
        \xa75000 Bon, alors.
        \xa72000 Que fabrique-t-il ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Je crois qu\u2019il faisait juste des exercices physiques.",
                $54444fb6f1edcc88$var$passageF
            ],
            "2": [
                "Peut-\xeatre qu\u2019il creuse ?",
                $54444fb6f1edcc88$var$passageG
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageF() {
    const seq = `
        \xa72000 Wha\xa71000\xa7\xa7\xa7Non ${$54444fb6f1edcc88$var$userName} !
        Il ne faisait pas juste des exercices physiques...
        
        \xa78000 Vous croyez que tout \xe7a n\u{2019}est qu\u{2019}un jeu ?
        \xa73000 Que vous pouvez choisir comme bon vous semble ?
        
        \xa75000 Concentrez-vous un peu !
        Alors ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Alors... il creuse ! ",
                $54444fb6f1edcc88$var$passageG
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageG() {
    const seq = `
        \xa73000 Tr\xe8s juste... \xa72000 en effet.
        Il creuse.
        
        \xa75000 Il creuse pour enterrer... \xa72000 quelque chose.
        
        \xa78000 Et je crois que \xe7a vous effraie.
        Avait-il une arme ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Il me semble que oui.",
                $54444fb6f1edcc88$var$passageH
            ],
            "2": [
                "Ca fait tr\xe8s s\xe9rie B !",
                $54444fb6f1edcc88$var$passageH2
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageH() {
    const seq = `
        \xa72000 Vous n'\xeates pas s\xfbr ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $54444fb6f1edcc88$var$passageHI();
    });
}
function $54444fb6f1edcc88$var$passageH2() {
    const seq = `
        \xa72000 Tr\xeave de plaisanterie ${$54444fb6f1edcc88$var$userName} !
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $54444fb6f1edcc88$var$passageHI();
    });
}
function $54444fb6f1edcc88$var$passageHI() {
    const seq = `
        \xa73000 Vous avez au moins le souvenir d\u{2019}avoir trouv\xe9 cet individu tr\xe8s dangereux...
        Il vous faudra fuir \xe0 la moindre occasion !
        
        \xa74000 Attendez ! Chut ! Taisez-vous !
        Une voiture arrive...
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("", "col-green");
        $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
        $54444fb6f1edcc88$var$oneShots.push($a4c2b5f01dd377d1$exports.play("voiture-arrive", {
            onended: $54444fb6f1edcc88$var$passageHI2
        }).fadeTo(4.0, $54444fb6f1edcc88$var$audioLevels["voiture-arrive"]));
    });
}
function $54444fb6f1edcc88$var$passageHI2() {
    $54444fb6f1edcc88$var$loops.radioLoin = $a4c2b5f01dd377d1$exports.play("radio-loin", {
        loop: true
    }).fadeTo(1.0, $54444fb6f1edcc88$var$audioLevels["radio-loin"]);
    const seq = `
        \xa72000 Etrange.
        La porti\xe8re est rest\xe9e ouverte.
        On entend d\u{2019}ici l\u{2019}autoradio.

        Vous \xeates \xe0 quelques m\xe8tres de la voiture mais...
        \xa73000 Y avait-il vraiment quelqu'un au volant ?
        
        \xa75000 Et pourquoi l\u{2019}autre continue de creuser ?
        Votre m\xe9moire est floue ${$54444fb6f1edcc88$var$userName}.
        
        \xa75000 Cette voiture vous attire. Que faites-vous ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtStart: false
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Je cours vers la voiture pour la voler et m\u2019enfuir !",
                $54444fb6f1edcc88$var$passageK
            ],
            "2": [
                "J\u2019attends un moment plus propice.  ",
                $54444fb6f1edcc88$var$passageJ
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageJ() {
    const seq = `
        \xa73000 La prudence \xe9tait votre boussole... \xa71000 c\u{2019}est bien.
        
        \xa73000 Vous \xeates sage... \xa71000 raisonnable.
        Vous attendez donc.
        
        \xa74000 \xc7a risque de durer quelques minutes...
        
        \xa74000 Une cigarette ?
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Oui, une clope, avec plaisir !",
                $54444fb6f1edcc88$var$passageL2
            ],
            "2": [
                "Pourquoi pas. Mais seulement une e-cigarette.",
                $54444fb6f1edcc88$var$passageL1
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageK() {
    $54444fb6f1edcc88$var$loops.courseMort = $a4c2b5f01dd377d1$exports.play("course-mort", {
        loop: true,
        loopStart: 20.0,
        loopEnd: 24.105
    }).fadeTo(2, $54444fb6f1edcc88$var$audioLevels["course-mort"]);
    setTimeout(()=>{
        $54444fb6f1edcc88$var$loops.pelle.fade(1);
        $54444fb6f1edcc88$var$loops.foret.fade(1);
        if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fade(1);
        if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fade(1);
        $54444fb6f1edcc88$var$loops.radioLoin.fade(1);
    }, 7000); // Coup de feu à 7 secondes
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("Vous courez vers la voiture", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        const seq = `
            \xa71000 La mort ?
            
            \xa73000 D\xe9j\xe0 ? \xa74000 Vous \xeates s\xfbr ?
            
            \xa73000 Non \xe7a ne doit pas \xeatre \xe7a...
            `;
        $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
                "1": [
                    "Revenir en arri\xe8re",
                    $54444fb6f1edcc88$var$passageK2
                ]
            });
        });
    }, 18000);
}
function $54444fb6f1edcc88$var$passageK2() {
    $54444fb6f1edcc88$var$loops.courseMort.fade(1, -90, true);
    $54444fb6f1edcc88$var$oneShots.push($a4c2b5f01dd377d1$exports.play("course-mort-rev", {
        onended: $54444fb6f1edcc88$var$passageK3
    }).fadeTo(1, $54444fb6f1edcc88$var$audioLevels["course-mort-rev"]));
}
function $54444fb6f1edcc88$var$passageK3() {
    $54444fb6f1edcc88$var$loops.pelle.fadeTo(1, $54444fb6f1edcc88$var$audioLevels["pelle"]);
    $54444fb6f1edcc88$var$loops.foret.fadeTo(1, $54444fb6f1edcc88$var$audioLevels["foret"]);
    if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fadeTo(1, $54444fb6f1edcc88$var$audioLevels["riviere"]);
    if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fadeTo(1, $54444fb6f1edcc88$var$audioLevels["autoroute"]);
    $54444fb6f1edcc88$var$loops.radioLoin.fadeTo(1, $54444fb6f1edcc88$var$audioLevels["radio-loin"]);
    const seq = `
        \xa72000 Vous \xeatiez \xe0 quelques m\xe8tres de la voiture.
        Elle semble \xeatre venue pour vous, mais...
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "J\u2019attends un moment plus propice.",
                $54444fb6f1edcc88$var$passageJ
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageL1() {
    // Fade out to pause
    $54444fb6f1edcc88$var$loops.pelle.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.foret.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.radioLoin.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.attenteVaporette = $a4c2b5f01dd377d1$exports.play("attente-vaporette", {
        initialGain: $54444fb6f1edcc88$var$audioLevels["attente-vaporette"],
        when: 2,
        loop: true,
        loopStart: 5.0,
        loopEnd: 28.0,
        onended: $54444fb6f1edcc88$var$passageL
    });
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("Vous utilisez une e-cigarette", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
        $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Arreter de vapoter",
                ()=>{
                    $54444fb6f1edcc88$var$loops.attenteVaporette.fade(2, -90, true);
                }
            ]
        });
    }, 3000);
}
function $54444fb6f1edcc88$var$passageL2() {
    // Fade out to pause
    $54444fb6f1edcc88$var$loops.pelle.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.foret.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.radioLoin.fade(2, $54444fb6f1edcc88$var$audioLevels["attenuation-attente"]);
    $54444fb6f1edcc88$var$loops.attenteCigarette = $a4c2b5f01dd377d1$exports.play("attente-cigarette", {
        initialGain: $54444fb6f1edcc88$var$audioLevels["attente-cigarette"],
        when: 2,
        loop: true,
        loopStart: 1.0,
        loopEnd: 11.5,
        onended: $54444fb6f1edcc88$var$passageL
    });
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("Vous fumez une cigarette", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
        $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Eteindre la cigarette",
                ()=>{
                    $54444fb6f1edcc88$var$loops.attenteCigarette.loop = false;
                }
            ]
        });
    }, 3000);
}
function $54444fb6f1edcc88$var$passageL() {
    // Fade back in from pause
    $54444fb6f1edcc88$var$loops.foret.fadeTo(2, $54444fb6f1edcc88$var$audioLevels["foret"]);
    if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fadeTo(2, $54444fb6f1edcc88$var$audioLevels["riviere"]);
    if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fadeTo(2, $54444fb6f1edcc88$var$audioLevels["autoroute"]);
    $54444fb6f1edcc88$var$loops.radioLoin.fadeTo(2, $54444fb6f1edcc88$var$audioLevels["radio-loin"]);
    $54444fb6f1edcc88$var$loops.pelle.fade(1, -90, true);
    const seq = `
        \xa72000 Vous \xeates toujours l\xe0 ?
        
        \xa73000 Ecoutez !
        \xa74000 Il n\u{2019}y a plus personne ?
        
        \xa78000 Le type qui creuse est parti...
        
        \xa74000 La voiture est toujours l\xe0... \xa71000 pr\xeate \xe0 l\u{2019}emploi.
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Quand faut y aller, faut y aller !",
                $54444fb6f1edcc88$var$passageM
            ],
            "2": [
                "Partir \xe0 la recherche du type qui creusait ?",
                $54444fb6f1edcc88$var$passageM2
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageM() {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("Vous marchez vers la voiture", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$loops.radioLoin.fade(12, 6);
    $54444fb6f1edcc88$var$oneShots.push($a4c2b5f01dd377d1$exports.play("pas", {
        initialGain: $54444fb6f1edcc88$var$audioLevels["pas"],
        onended: ()=>{
            $54444fb6f1edcc88$var$loops.voitureRadio = $a4c2b5f01dd377d1$exports.play("voiture-entree", {
                initialGain: $54444fb6f1edcc88$var$audioLevels["voiture-entree"],
                loop: true,
                loopStart: 3.591,
                loopEnd: 16.5
            });
            // Diminuer ou arrêter les sons
            $54444fb6f1edcc88$var$loops.foret.fade(1, $54444fb6f1edcc88$var$audioLevels["attenuation-voiture"], true);
            if ($54444fb6f1edcc88$var$loops.riviere) $54444fb6f1edcc88$var$loops.riviere.fade(1, $54444fb6f1edcc88$var$audioLevels["attenuation-voiture"], true);
            if ($54444fb6f1edcc88$var$loops.autoroute) $54444fb6f1edcc88$var$loops.autoroute.fade(1, $54444fb6f1edcc88$var$audioLevels["attenuation-voiture"], true);
            $54444fb6f1edcc88$var$loops.radioLoin.fade(1, $54444fb6f1edcc88$var$audioLevels["attenuation-voiture"], true);
            const seq = `
                \xa72000 Vous voil\xe0 dans la voiture.
                Vous vous en souvenez ?

                \xa72000 La radio baragouinait des inepties contemporaines...
                Y avait comme un bug.
                
                \xa72000 Vous vous en souvenez ?
            `;
            $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
                /* Sequence options */ color: "col-green",
                lead: "Nar-6> ",
                teletypeDelay: "human"
            }, ()=>{
                /* Sequence callback */ $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
                    "1": [
                        "Taper sur la gauche de la radio",
                        $54444fb6f1edcc88$var$passageN1
                    ],
                    "2": [
                        "Taper sur la droite de la radio",
                        $54444fb6f1edcc88$var$passageN2
                    ]
                });
            });
        }
    }));
}
function $54444fb6f1edcc88$var$passageM2() {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("<Error: Memory address out of range>", "col-dark-red", "italic");
    $dbf687474781ee90$export$a23ad60f6022999e("error");
    $54444fb6f1edcc88$var$timeout = setTimeout(()=>{
        const seq = `
            \xa75000 Oups d\xe9sol\xe9, je crois qu'il y a une erreur
            Ces souvenirs ne sont pas accessibles...
            
            \xa73000 Peut-\xeatre faut-il attendre une mise \xe0 jour ?
            `;
        $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
                "1": [
                    "Revenir au choix pr\xe9c\xe9dent",
                    $54444fb6f1edcc88$var$passageM3
                ]
            });
        });
    }, 2000);
}
function $54444fb6f1edcc88$var$passageM3() {
    const seq = `
        \xa72000 Donc le type qui creuse est parti.

        \xa72000 La voiture est toujours l\xe0... pr\xeate \xe0 l\u{2019}emploi.
        `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        $e1cdaf3feaf9d5df$export$7a5825874deea16a("", {
            "1": [
                "Quand faut y aller, faut y aller !",
                $54444fb6f1edcc88$var$passageM
            ]
        });
    });
}
function $54444fb6f1edcc88$var$passageN1() {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("La radio diffuse de la musique", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$loops.voitureRadio.fade(1, -90, true);
    $54444fb6f1edcc88$var$oneShots.push($a4c2b5f01dd377d1$exports.play("fin-jazz", {
        initialGain: $54444fb6f1edcc88$var$audioLevels["fin-jazz"],
        onended: ()=>{
            $54444fb6f1edcc88$export$5c525e238923a57d();
        }
    }));
    $54444fb6f1edcc88$var$timeout = setTimeout($54444fb6f1edcc88$var$passageO, 20000);
}
function $54444fb6f1edcc88$var$passageN2() {
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    $e1cdaf3feaf9d5df$export$21a5ca8aa77d35ff("La radio diffuse de la musique", "col-light-gray", "italic");
    $e1cdaf3feaf9d5df$export$e5383273bc7bedd();
    $54444fb6f1edcc88$var$loops.voitureRadio.fade(1, -90, true);
    $54444fb6f1edcc88$var$oneShots.push($a4c2b5f01dd377d1$exports.play("fin-electro", {
        initialGain: $54444fb6f1edcc88$var$audioLevels["fin-electro"],
        onended: ()=>{
            $54444fb6f1edcc88$export$5c525e238923a57d();
        }
    }));
    $54444fb6f1edcc88$var$timeout = setTimeout($54444fb6f1edcc88$var$passageO, 20000);
}
function $54444fb6f1edcc88$var$passageO() {
    const seq = `
        \xa72000 Vous avez fui !
        
        \xa78000 Vous \xeates en s\xe9curit\xe9. 
        
        \xa78000 Au moins pour un moment...
        
        \xa78000 Vous \xeates en route pour d\u{2019}autres aventures,
        
        \xa78000 d\u{2019}autres embranchements.

        \xa78000 Bient\xf4t...
    `;
    $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
    // timeout = setTimeout(() => {
    //     exit();
    // }, 8000);
    });
}
function $54444fb6f1edcc88$var$stopAllSounds() {
    $54444fb6f1edcc88$var$oneShots.forEach((source)=>source.stop());
    Object.values($54444fb6f1edcc88$var$loops).forEach((source)=>source.stop());
}
function $54444fb6f1edcc88$export$5c525e238923a57d() {
    $54444fb6f1edcc88$var$stopAllSounds();
    $e1cdaf3feaf9d5df$export$42ffd38884aecdac();
    $54444fb6f1edcc88$var$exitCallback();
}


// Variables
let $3326721cc4adb9d3$var$keyBoardResponsive = true;
let $3326721cc4adb9d3$var$address;
let $3326721cc4adb9d3$var$audioSource;
// Configuration
const $3326721cc4adb9d3$var$dialUp = true;
// Game data
const $3326721cc4adb9d3$var$addresses = {
    "10.1.2.3": $54444fb6f1edcc88$exports
};
function $3326721cc4adb9d3$export$889ea624f2cb2c57(...args) {
    $3326721cc4adb9d3$var$keyBoardResponsive = true;
    $3326721cc4adb9d3$var$address = args[0] || "";
    $e1cdaf3feaf9d5df$export$a1544dad697b423d();
    $e1cdaf3feaf9d5df$export$42ffd38884aecdac();
    // Header
    $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        100,
        "AutronaTerm v2.5 - 802.11",
        "!s:col-red",
        "!s:col-bg-red",
        100,
        "!n",
        100,
        "!n"
    ];
    $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq, ()=>{
        if ($3326721cc4adb9d3$var$address) {
            $e1cdaf3feaf9d5df$export$10d8903dec122b9d("Connecting to " + $3326721cc4adb9d3$var$address);
            $3326721cc4adb9d3$var$openConnection();
        } else {
            $e1cdaf3feaf9d5df$export$10d8903dec122b9d("Enter remote terminal address > ");
            $e1cdaf3feaf9d5df$export$58734539bbfa41a2();
        }
    });
}
function $3326721cc4adb9d3$var$openConnection() {
    $3326721cc4adb9d3$var$keyBoardResponsive = false;
    if ($3326721cc4adb9d3$var$address in $3326721cc4adb9d3$var$addresses) {
        if ($3326721cc4adb9d3$var$dialUp) {
            // Play modem dial up sound
            $3326721cc4adb9d3$var$audioSource = $a4c2b5f01dd377d1$exports.play("dial-up-modem", {
                initialGain: -20
            });
            // Screen sequence. See screen.js comments for documentation
            const seq = `
                \xa71000<opening line>
                \xa7800<dialing ISP...>
                \xa74300<initiating connection...>
                \xa73900<negotiating modulation mode...>
                \xa73200<probing line...>
                \xa71400<adjusting equalizers...>

                \xa79200<connection established>

                \xa72200<muting modem>

                \xa7500<remote tty override from ${$3326721cc4adb9d3$var$address}>
            `.trim();
            $e1cdaf3feaf9d5df$export$b28a6436aebad9c0(seq, {
                color: [
                    "col-dark-green",
                    "italic"
                ],
                mode: "line",
                lineDelay: 0,
                endDelay: 0
            }, ()=>{
                setTimeout(()=>{
                    $3326721cc4adb9d3$var$stopSounds();
                    $3326721cc4adb9d3$var$addresses[$3326721cc4adb9d3$var$address].run($3326721cc4adb9d3$var$exit);
                }, 2000);
            });
        } else {
            $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
            // Screen sequence. See screen.js comments for documentation
            const seq = [
                100,
                "!s:col-dark-green",
                "<initiating connection...>",
                "!n",
                5160,
                "!s:col-green",
                "<connection established>",
                "!n"
            ];
            $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq, ()=>{
                $dbf687474781ee90$export$a23ad60f6022999e("connected");
                setTimeout(()=>{
                    $3326721cc4adb9d3$var$stopSounds();
                    $3326721cc4adb9d3$var$addresses[$3326721cc4adb9d3$var$address].run($3326721cc4adb9d3$var$exit);
                }, 1000);
            });
        }
    } else {
        console.log("Bad address: " + $3326721cc4adb9d3$var$address);
        $3326721cc4adb9d3$var$address = "";
        $e1cdaf3feaf9d5df$export$dc84f6841f96b7da();
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            100,
            "!s:col-dark-green",
            "<initiating connection...>",
            "!n",
            5160,
            "!s:col-dark-red",
            "<unable to reach host>",
            "!n",
            100,
            "Enter remote terminal address > "
        ];
        $e1cdaf3feaf9d5df$export$49bb65c2ea163039(seq, ()=>{
            $dbf687474781ee90$export$a23ad60f6022999e("error");
            $e1cdaf3feaf9d5df$export$58734539bbfa41a2();
            $3326721cc4adb9d3$var$keyBoardResponsive = true;
        });
    }
}
function $3326721cc4adb9d3$var$stopSounds() {
    if ($3326721cc4adb9d3$var$audioSource) $3326721cc4adb9d3$var$audioSource.stop();
}
function $3326721cc4adb9d3$var$exit() {
    console.log("Remote program exit");
}




function $0c13558fa724b711$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $569bd9143eae2355$export$fbb4d68fe60c1629().then(()=>{
            $dbf687474781ee90$export$b3571188c770cc5a();
        });
    });
}
function $0c13558fa724b711$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $0c13558fa724b711$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $0c13558fa724b711$export$471f7ae5c4103ae1(null);
}



var $699f0a9b134cbeba$exports = {};
$699f0a9b134cbeba$exports = new URL("../ui-pack.01f87fb1.aac", import.meta.url).toString();


var $7226436e80f47e15$exports = {};
$7226436e80f47e15$exports = new URL("../Dial_up_modem_noises.fcf212dc.aac", import.meta.url).toString();


var $1a4ff874a1e482f3$exports = {};
$1a4ff874a1e482f3$exports = new URL("../Foret-fix.bf0ea3fb.aac", import.meta.url).toString();


var $eb64b3f214513a39$exports = {};
$eb64b3f214513a39$exports = new URL("../Branches.65b0f8e3.m4a", import.meta.url).toString();


var $2dce1ef2857478bd$exports = {};
$2dce1ef2857478bd$exports = new URL("../Pelle.ce95812f.m4a", import.meta.url).toString();


var $702f054095edcbec$exports = {};
$702f054095edcbec$exports = new URL("../Riviere.b3d87571.m4a", import.meta.url).toString();


var $113d8b38eea62401$exports = {};
$113d8b38eea62401$exports = new URL("../Autoroute.a945b89c.m4a", import.meta.url).toString();


var $ace1bf62e09a02f0$exports = {};
$ace1bf62e09a02f0$exports = new URL("../Voiture_arriv.353e4d3b.m4a", import.meta.url).toString();


var $c87a02ca26bc7f68$exports = {};
$c87a02ca26bc7f68$exports = new URL("../Radio_loin.145b3ba9.m4a", import.meta.url).toString();


var $5e65e3dc0c9c9898$exports = {};
$5e65e3dc0c9c9898$exports = new URL("../Course_mort.543d9aeb.m4a", import.meta.url).toString();


var $14de36fc9e679c6b$exports = {};
$14de36fc9e679c6b$exports = new URL("../Course_mort_reverse.d7569a14.m4a", import.meta.url).toString();


var $57a0fbf7fb819f89$exports = {};
$57a0fbf7fb819f89$exports = new URL("../Attente_cig.2a7016e0.m4a", import.meta.url).toString();


var $84b37f0d6577719e$exports = {};
$84b37f0d6577719e$exports = new URL("../Attente_vapor.59622743.m4a", import.meta.url).toString();


var $58755fd6f9566ba9$exports = {};
$58755fd6f9566ba9$exports = new URL("../Voiture_entree.f030b173.m4a", import.meta.url).toString();


var $ab5c5365840e65cf$exports = {};
$ab5c5365840e65cf$exports = new URL("../Pas.d3f95d51.m4a", import.meta.url).toString();


var $11dac3d47289b939$exports = {};
$11dac3d47289b939$exports = new URL("../Fin1_gauche_jazz.62b83880.m4a", import.meta.url).toString();


var $bf19a4f28b496dee$exports = {};
$bf19a4f28b496dee$exports = new URL("../Fin2_droite_electro.9cda9c9d.m4a", import.meta.url).toString();


const $8a9d17849b677181$var$sounds = [
    {
        name: "ui-pack",
        url: new URL($699f0a9b134cbeba$exports)
    },
    {
        name: "dial-up-modem",
        url: new URL($7226436e80f47e15$exports)
    },
    {
        name: "foret",
        url: new URL($1a4ff874a1e482f3$exports)
    },
    {
        name: "branches",
        url: new URL($eb64b3f214513a39$exports)
    },
    {
        name: "pelle",
        url: new URL($2dce1ef2857478bd$exports)
    },
    {
        name: "riviere",
        url: new URL($702f054095edcbec$exports)
    },
    {
        name: "autoroute",
        url: new URL($113d8b38eea62401$exports)
    },
    {
        name: "voiture-arrive",
        url: new URL($ace1bf62e09a02f0$exports)
    },
    {
        name: "radio-loin",
        url: new URL($c87a02ca26bc7f68$exports)
    },
    {
        name: "course-mort",
        url: new URL($5e65e3dc0c9c9898$exports)
    },
    {
        name: "course-mort-rev",
        url: new URL($14de36fc9e679c6b$exports)
    },
    {
        name: "attente-cigarette",
        url: new URL($57a0fbf7fb819f89$exports)
    },
    {
        name: "attente-vaporette",
        url: new URL($84b37f0d6577719e$exports)
    },
    {
        name: "voiture-entree",
        url: new URL($58755fd6f9566ba9$exports)
    },
    {
        name: "pas",
        url: new URL($ab5c5365840e65cf$exports)
    },
    {
        name: "fin-jazz",
        url: new URL($11dac3d47289b939$exports)
    },
    {
        name: "fin-electro",
        url: new URL($bf19a4f28b496dee$exports)
    }
];
function $8a9d17849b677181$export$2cd8252107eb640b() {
    $8a9d17849b677181$var$setupMobileKeyboard();
    return $8a9d17849b677181$var$loadSounds();
}
function $8a9d17849b677181$var$loadSounds() {
    return Promise.all([
        ...$8a9d17849b677181$var$sounds.map((sound)=>{
            return $a4c2b5f01dd377d1$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $8a9d17849b677181$var$setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector(".screen");
    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener("click", ()=>{
        const input = document.querySelector(".mobile-input");
        input.focus();
    });
    // Prevent hitting enter submitting the mobile form for input
    document.querySelector("form").addEventListener("keypress", (e)=>e.preventDefault());
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
function $dbf687474781ee90$export$a23ad60f6022999e(name) {
    // TODO: refactor this
    const effects = {
        "validate": {
            initialGain: -12,
            offset: 0.100,
            duration: 0.093
        },
        "error": {
            initialGain: -12,
            offset: 0.200,
            duration: 0.175
        },
        "success": {
            initialGain: -12,
            offset: 0.400,
            duration: 0.148
        },
        "question": {
            initialGain: -12,
            offset: 0.600,
            duration: 0.131
        },
        "notify": {
            initialGain: -12,
            offset: 0.800,
            duration: 0.340
        },
        "connected": {
            initialGain: -18,
            offset: 1.200,
            duration: 0.147
        },
        "disconnected": {
            initialGain: -18,
            offset: 1.400,
            duration: 0.297
        },
        "connecting": {
            initialGain: -18,
            offset: 1.800,
            duration: 5.160
        }
    };
    if (!(name in effects)) return console.error("Error: Uknown soundEffect: " + name);
    $a4c2b5f01dd377d1$exports.play("ui-pack", effects[name]);
}
function $dbf687474781ee90$var$init() {
    $0c13558fa724b711$export$2cd8252107eb640b();
    $0c13558fa724b711$export$471f7ae5c4103ae1("Initializing...");
    $569bd9143eae2355$export$2cd8252107eb640b();
    $e1cdaf3feaf9d5df$export$2cd8252107eb640b();
    $0c13558fa724b711$export$471f7ae5c4103ae1("Loading...");
    $8a9d17849b677181$export$2cd8252107eb640b().then(()=>{
        $0c13558fa724b711$export$4bb981a91e4f02eb();
    });
}
function $dbf687474781ee90$export$b3571188c770cc5a() {
    $3326721cc4adb9d3$export$889ea624f2cb2c57("10.1.2.3");
}
$dbf687474781ee90$var$init();


//# sourceMappingURL=index.77fbb168.js.map
